import { render, staticRenderFns } from "./_code.vue?vue&type=template&id=c4078fbc&scoped=true"
import script from "./script.ts?vue&type=script&lang=ts&external"
export * from "./script.ts?vue&type=script&lang=ts&external"
import style0 from "./style.scss?vue&type=style&index=0&id=c4078fbc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4078fbc",
  null
  
)

export default component.exports